import { render, staticRenderFns } from "./PreiviewImg.vue?vue&type=template&id=1511b916&scoped=true";
import script from "./PreiviewImg.vue?vue&type=script&lang=js";
export * from "./PreiviewImg.vue?vue&type=script&lang=js";
import style0 from "./PreiviewImg.vue?vue&type=style&index=0&id=1511b916&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "1511b916", null);
export default component.exports;